<template>
  <PSUserMonitor />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
